// extracted by mini-css-extract-plugin
module.exports = {"authorization-heading":"AuthorizationHistoryModal_authorization-heading__3YW2_"};